import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ScheduleCamp from './scheduleCamp';
import {
  createCamp,
  getPocList,
  getMeetingById,
  updateMeeting,
  getCampList,
} from 'services/redux/brandActivtion/conductCamp/action';
import { documentUploadUrl } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
  pocList: state.ConductCampReducer.pocList,
  meetingById: state.ConductCampReducer.meetingById,
  documentUrlData: state.fileUploadReducer.documentUrlData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPocList,
      createCamp,
      getCampList,
      getMeetingById,
      updateMeeting,
      documentUploadUrl,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleCamp);
